import { FC } from "react";

import "./index.scss";
import Customization from "@app/containers/customization";

const AddCustomizationPage: FC = () => <Customization />;

export default AddCustomizationPage;
